/* Loads Shopify's product recommendations once the block is near the viewport. */
(function () {
  'use strict';

  if (customElements.get('product-recommendations')) return;

  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.url) return;
        this.loaded = false;

        var load = function () {
          fetch(this.dataset.url)
            .then(function (response) {
              return response.text();
            })
            .then(
              function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var incoming = doc.querySelector('product-recommendations');
                if (incoming && incoming.innerHTML.trim().length) this.innerHTML = incoming.innerHTML;
              }.bind(this)
            )
            .catch(function () {
              /* Recommendations are an enhancement; a failure leaves the page intact. */
            });
        }.bind(this);

        var once = function () {
          if (this.loaded) return;
          this.loaded = true;
          load();
        }.bind(this);

        /* Inside the cart drawer the element is hidden until the drawer opens,
           so an intersection observer would never fire. Wait for the open
           instead. */
        if (this.dataset.loadOn === 'cart-open') {
          document.addEventListener('sloos:cart:opened', once);
          return;
        }

        if (!('IntersectionObserver' in window)) {
          once();
          return;
        }

        var observer = new IntersectionObserver(
          function (entries) {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            once();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );

        observer.observe(this);
      }
    }
  );
})();
